import React, { createContext, useContext, useEffect, useState } from "react";

import { getMyPermissions } from "../services/rbac.service";
import PropTypes from "prop-types";
const RbacContext = createContext(null);

export const RbacProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  const [loading, setLoading] = useState(true);

  const loadPermissions = async () => {
    try {
      setLoading(true);

      const data = await getMyPermissions();

      setPermissions(data || []);
    } catch (error) {
      console.error("RBAC permission loading failed", error);

      setPermissions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPermissions();
  }, [sessionStorage.getItem("college_id")]);

  const hasAction = (moduleCode, tabCode, buttonCode, actionCode) => {
    return permissions.some((permission) => {
      const action = permission.action;

      const button = action?.button;

      const tab = button?.tab;

      const module = tab?.module;

      return (
        module?.module_code === moduleCode &&
        tab?.tab_code === tabCode &&
        button?.button_code === buttonCode &&
        action?.action_code === actionCode
      );
    });
  };

  const hasButton = (moduleCode, tabCode, buttonCode) => {
    return permissions.some((permission) => {
      const action = permission.action;

      const button = action?.button;

      const tab = button?.tab;

      const module = tab?.module;

      return (
        module?.module_code === moduleCode &&
        tab?.tab_code === tabCode &&
        button?.button_code === buttonCode
      );
    });
  };

  const hasTab = (moduleCode, tabCode) => {
    return permissions.some((permission) => {
      const module = permission.action?.button?.tab?.module;

      const tab = permission.action?.button?.tab;

      return module?.module_code === moduleCode && tab?.tab_code === tabCode;
    });
  };

  const hasModule = (moduleCode) => {
    return permissions.some(
      (permission) => permission.action?.button?.tab?.module?.module_code === moduleCode
    );
  };

  return (
    <RbacContext.Provider
      value={{
        permissions,
        loading,
        loadPermissions,
        hasAction,
        hasButton,
        hasTab,
        hasModule,
      }}
    >
      {children}
    </RbacContext.Provider>
  );
};

export const useRbac = () => {
  const context = useContext(RbacContext);

  if (!context) {
    throw new Error("useRbac must be used inside RbacProvider");
  }

  return context;
};

RbacProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
